import React from 'react';
import { Card, CardContent } from './ui/card';
import { Paintbrush, Hammer, Droplets, Grid3x3, Wrench } from 'lucide-react';

export const ServicesSection = () => {
  const services = [
    {
      icon: Paintbrush,
      title: 'Peinture',
      description: 'Peinture intérieure et extérieure, revêtements muraux, finitions décoratives pour embellir vos espaces.',
      image: 'https://images.unsplash.com/photo-1745665777586-09381ba528d6?w=800&q=80',
      features: ['Peinture intérieure', 'Peinture extérieure', 'Revêtements muraux', 'Finitions décoratives']
    },
    {
      icon: Hammer,
      title: 'Plâtrerie',
      description: 'Pose de cloisons, isolation, enduits et finitions pour des surfaces parfaites et durables.',
      image: 'https://images.unsplash.com/photo-1543525324-26e03b510586?w=800&q=80',
      features: ['Pose de cloisons', 'Isolation thermique', 'Enduits et finitions', 'Faux plafonds']
    },
    {
      icon: Droplets,
      title: 'Plomberie',
      description: 'Installation, réparation et entretien de vos installations sanitaires et systèmes de chauffage.',
      image: 'https://images.unsplash.com/photo-1676210134188-4c05dd172f89?w=800&q=80',
      features: ['Installation sanitaire', 'Mitigeurs & robinetterie', 'Radiateurs & chauffage', 'Dépannage urgence']
    },
    {
      icon: Grid3x3,
      title: 'Sols et Carrelage',
      description: 'Pose et rénovation de tous types de sols : carrelage, faïence, parquet pour un rendu impeccable.',
      image: 'https://images.unsplash.com/photo-1767634920578-fec1a2580c00?w=800&q=80',
      features: ['Carrelage intérieur', 'Faïence salle de bain', 'Pose de parquet', 'Rénovation de sols']
    },
    {
      icon: Wrench,
      title: 'Travaux de Bricolage',
      description: 'Petits travaux de réparation, fixations, montage et entretien pour votre confort au quotidien.',
      image: 'https://images.pexels.com/photos/4312841/pexels-photo-4312841.jpeg?w=800&q=80',
      features: ['Fixations murales', 'Montage meubles', 'Petites réparations', 'Entretien courant']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Services
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Une expertise complète pour tous vos travaux de second œuvre
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <Card
              key={index}
              className="group overflow-hidden hover:shadow-2xl transition-all duration-500 border-none bg-white transform hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 via-blue-900/50 to-transparent"></div>
                
                {/* Icon */}
                <div className="absolute bottom-4 left-4 w-16 h-16 bg-white rounded-2xl flex items-center justify-center shadow-lg transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                  <service.icon className="text-blue-600" size={32} />
                </div>
              </div>

              <CardContent className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6">
                  {service.description}
                </p>
                
                {/* Features List */}
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mr-3"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
